import { IUserAction, IUserState } from 'models/user'
import { UserActionsTypes } from './actions'
import {
  defaultProxyPackages,
  defaultProxyHosts,
} from '../../utils/proxy/proxyConstants'

const initialState: IUserState = {
  initialLoading: true,
  isUserInitFailed: false,
  fetching: false,
  userOverviewFetching: false,
  userCustomerView: null,
  userSubscriptionView: null,
  userBalanceView: null,
  userScrapperView: null,
  userProxyView: null,
  subscriptionInfo: null,
  subscriptionInfoFetching: false,
  balanceInfo: null,
  balanceInfoFetching: false,
  statsUrlFetching: false,
  userStatsUrl: null,
  firstName: null,
  lastName: null,
  email: null,
  tempFirstName: null,
  tempLastName: null,
  scrapperApiKey: 'SUBSCRIBE_TO_USE',
  scrapperApiKeyFetching: true,
  proxyPackages: defaultProxyPackages,
  proxyPackagesFetching: true,
  intercomHash: null,
  userHash: null,
  availableHosts: defaultProxyHosts,
  isEnterpriseActive: false,
  isResellerActive: false,
}

const userReducer = (state: IUserState = initialState, action: IUserAction) => {
  switch (action.type) {
    case UserActionsTypes.USER_INITIALIZE:
      return {
        ...state,
        initialLoading: true,
        isUserInitFailed: false,
      }
    case UserActionsTypes.USER_INITIALIZE_SUCCESS:
      return {
        ...state,
        initialLoading: false,
        isUserInitFailed: false,
        intercomHash: action.intercomHash,
        userHash: action.userHash,
      }
    case UserActionsTypes.USER_INITIALIZE_FAIL:
      return {
        ...state,
        initialLoading: false,
        isUserInitFailed: true,
      }

    case UserActionsTypes.USER_GET_OVERVIEW:
      return {
        ...state,
        userOverviewFetching: true,
      }
    case UserActionsTypes.USER_GET_OVERVIEW_SUCCESS:
      return {
        ...state,
        userCustomerView: action.userCustomerView,
        userSubscriptionView: action.userSubscriptionView,
        userBalanceView: action.userBalanceView,
        userScrapperView: action.userScrapperView,
        userProxyView: action.userProxyView,
        userOverviewFetching: false,
      }
    case UserActionsTypes.USER_GET_OVERVIEW_FAIL:
      return {
        ...state,
        userOverviewFetching: false,
      }

    case UserActionsTypes.USER_GET_BALANCE:
      return {
        ...state,
        balanceInfoFetching: true,
      }
    case UserActionsTypes.USER_GET_BALANCE_SUCCESS:
      return {
        ...state,
        balanceInfo: action.balanceInfo,
        userStatsUrl: action.userStatsUrl,
        balanceInfoFetching: false,
      }
    case UserActionsTypes.USER_GET_BALANCE_FAIL:
      return {
        ...state,
        balanceInfoFetching: false,
      }

    case UserActionsTypes.USER_GET_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptionInfoFetching: true,
      }
    case UserActionsTypes.USER_GET_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        subscriptionInfo: action.subscriptionInfo,
        subscriptionInfoFetching: false,
      }
    case UserActionsTypes.USER_GET_SUBSCRIPTIONS_FAIL:
      return {
        ...state,
        subscriptionInfoFetching: false,
      }

    case UserActionsTypes.USER_GET_STATS_URL:
      return {
        ...state,
        statsUrlFetching: true,
      }
    case UserActionsTypes.USER_GET_STATS_URL_SUCCESS:
      return {
        ...state,
        userStatsUrl: action.userStatsUrl,
        statsUrlFetching: false,
      }
    case UserActionsTypes.USER_GET_STATS_URL_FAIL:
      return {
        ...state,
        userStatsUrl: null,
        statsUrlFetching: false,
      }

    case UserActionsTypes.USER_SET_FIRST_NAME:
      return {
        ...state,
        firstName: action.firstName,
      }
    case UserActionsTypes.USER_SET_LAST_NAME:
      return {
        ...state,
        lastName: action.lastName,
      }
    case UserActionsTypes.USER_SET_EMAIL:
      return {
        ...state,
        email: action.email,
      }

    case UserActionsTypes.USER_SET_TEMP_FIRST_NAME:
      return {
        ...state,
        tempFirstName: action.tempFirstName,
      }
    case UserActionsTypes.USER_SET_TEMP_LAST_NAME:
      return {
        ...state,
        tempLastName: action.tempLastName,
      }

    case UserActionsTypes.USER_GET_SCRAPPER_API_KEY:
      return {
        ...state,
        scrapperApiKeyFetching: true,
      }
    case UserActionsTypes.USER_GET_SCRAPPER_API_KEY_SUCCESS:
      return {
        ...state,
        scrapperApiKeyFetching: false,
        scrapperApiKey: action.scrapperApiKey,
      }
    case UserActionsTypes.USER_GET_SCRAPPER_API_KEY_FAIL:
      return {
        ...state,
        scrapperApiKeyFetching: false,
      }

    case UserActionsTypes.USER_GET_PROXY_PACKAGES:
      return {
        ...state,
        proxyPackagesFetching: true,
      }
    case UserActionsTypes.USER_GET_PROXY_PACKAGES_SUCCESS:
      return {
        ...state,
        proxyPackagesFetching: false,
        proxyPackages: action.proxyPackages,
        availableHosts: action.availableHosts,
      }
    case UserActionsTypes.USER_GET_PROXY_PACKAGES_FAIL:
      return {
        ...state,
        proxyPackagesFetching: false,
      }

    case UserActionsTypes.USER_SET_ENTERPRISE_STATUS:
      return {
        ...state,
        isEnterpriseActive: action.isEnterpriseActive,
      }

    case UserActionsTypes.USER_SET_RESELLER_STATUS:
      return {
        ...state,
        isResellerActive: action.isResellerActive,
      }

    default:
      return state
  }
}

export default userReducer
